import styled from "styled-components";

export const ContainPagination = styled.div`
    display: flex;
    align-items: center;
    padding: 0 20px 0 26px;
    margin-top: 1rem;
`